<h2 mat-dialog-title *ngIf="data[0]?.fileId">ReOpen Case(s)</h2>
<h2 mat-dialog-title *ngIf="!data[0]?.fileId">ReOpen Correspondence(s)</h2>
<mat-dialog-content>
  <div>
    <form class="form-width" [formGroup]="expForm" #formDirective="ngForm">
      <mat-form-field class="full-width">
        <mat-label>Reason for Reopening </mat-label>
        <textarea
          matInput
          rows="6"
          cols="100"
          id="reason"
          formControlName="reason"
          (input)="str = $event.target.value"
        ></textarea>
        <mat-error>Provide a valid reason</mat-error>
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancel</button>
  <button
    mat-button
    mat-raised-button
    color="primary"
    (click)="onReopen()"
    [disabled]="expFormControl?.invalid"
  >
    ReOpen
  </button>
</mat-dialog-actions>
